module.exports = __webpack_public_path__ + "media/app/assets/images/klarna_badge-6b2819f9bcc3d5d2bc5916412a386b45.jpg";